// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"464":"search","639":"school"}[chunkId] + "." + {"464":"d053fd89","639":"d053fd89"}[chunkId] + ".css";
};